import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import CarouselStyles from './style';

function CarouselTag({ text }) {
    return (
        <Box component="span" sx={CarouselStyles.Tag.container}>
            {text}
        </Box>
    );
}

CarouselTag.propTypes = {
    text: PropTypes.string.isRequired,
};

export default CarouselTag;
